import { InfoCircledIcon } from '@radix-ui/react-icons'
import * as React from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/tooltip'

export const FieldDescription = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => {
  if (props.children) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger type="button">
            <InfoCircledIcon className="inline ml-2" />
          </TooltipTrigger>
          <TooltipContent>{props.children}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return null
})
FieldDescription.displayName = 'FormDescription'
